export const numbersHelper = {
	widgetCreated: '1M+',
	widgetInteracted: '50M+',
	widgetUsedByBusinesses: '500K+',
};
